/**
 * 判断url是否是http或https 
 * @param {string} path
 * @returns {Boolean}
 */
 export function isHttp(url) {
  return url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1
}

/**
 * 判断path是否为外链
 * @param {string} path
 * @returns {Boolean}
 */
 export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}


/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

/**
 * 判断字符串是否符合桩号格式
 * @param {string} str
 * @returns {Boolean}
 */
export function isStation(str) {
  // 验证规则:
  // 1. 桩号格式开头需为K或k
  // 2. 在k之后,"+"之前需为整数
  // 3. 在"+"之后需为浮点数,且小数点后最多3位,数值范围为0-999.999
  
  // 检查输入是否为字符串
  if (!isString(str)) {
    return false
  }
  
  // 正则表达式匹配桩号格式: K/k + 整数 + + + 0-999.999的浮点数
  const stationRegex = /^[Kk]\d+\+\d{1,3}(\.\d{1,3})?$/
  
  if (!stationRegex.test(str)) {
    return false
  }
  
  // 提取"+"号后的数值部分进行范围验证
  const plusIndex = str.indexOf('+')
  if (plusIndex === -1) {
    return false
  }
  
  const decimalPart = str.substring(plusIndex + 1)
  const decimalValue = parseFloat(decimalPart)
  
  // 验证数值范围: 0-999.999
  if (decimalValue < 0 || decimalValue > 999.999) {
    return false
  }
  
  // 验证小数点后最多3位
  if (decimalPart.includes('.')) {
    const decimalPlaces = decimalPart.split('.')[1].length
    if (decimalPlaces > 3) {
      return false
    }
  }
  
  return true
}
